/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - COLORS: STYLES --------------- ++++++++++ */
export default theme => ({
  colors: {
    '& .picker': {
      '& .chrome-picker': {
        '& > div:first-child': {
          display: 'none'
        },
        '& div:last-child > div:last-child > div:last-child': {
          display: 'block',
          marginTop: `0 !important`
        }
      },
    },
    '& .primarycolor': {
      '&.disabled-true': {
        '& .swatch': {
          pointerEvents: 'none'
        },
        '& input': {
          pointerEvents: 'none',
          opacity: 0.4
        }
      },
      '& .usemonochrome': {
        marginTop: pxToEm(16)
      },
    },
    '& .backgroundcolor': {
      '& .picker': {
        '& .chrome-picker': {
          '& > div:first-child': {
            display: 'block'
          },
        }
      },
      '& .colorpicker': {
        marginRight: '0'
      },
      '& .mode': {
        marginTop: pxToEm(20)
      }
    },
    '& .switch.thememode': {
      '&.active-true': {
        background: '#061240'
      },
      '&.active-false': {
        background: '#F9DA56',
        '&:hover': {
          background: `${convertHexToRGB('#F9DA56', 80)} !important`
        }
      }
    },
    '& .colorpicker': {
      width: 'auto',
      '& .picker': {
        '&.active': {
          zIndex: 4
        }
      }
    },
    '& .name-extensiondropdown': {
      width: pxToEm(300),
      zIndex: 3,
      '& .dropDownItem': {
        justifyContent: 'space-between'
      },
      '& .placeholdertext': {
        '& .colorpalette': {
          width: pxToEm(260)
        }
      },
      '& .placeholder .name-caret-down': {
        position: 'relative',
        top: pxToEm(-4)
      }
    }
  }
});
